import { Vector3 } from 'three';

const MAX_VECTOR_VALUE = new Vector3(Infinity, Infinity, Infinity);
const MIN_VECTOR_VALUE = new Vector3(-Infinity, -Infinity, -Infinity);
export class BoundingBox3 {
  private _min: Vector3;
  private _max: Vector3;

  constructor(min?: Vector3, max?: Vector3) {
    this._min = min || MAX_VECTOR_VALUE.clone();
    this._max = max || MIN_VECTOR_VALUE.clone();
  }

  get min() {
    return this._min;
  }

  get max() {
    return this._max;
  }

  get points() {
    /////////////////////////////
    //       7------------6    //
    //      / .         / |    //
    //     /  .        /  |    //
    //    4-----------5   |    //
    //    |   .       |   |    //
    //    |   .       |   |    //
    //    |   3.......|...2    //
    //    |  .        |  /     //
    //    | .         | /      //
    //    0-----------1        //
    //                         //
    //    | z     / y          //
    //    |     /              //
    //    |   /                //
    //    | /       x          //
    //    /— — — — — —         //
    /////////////////////////////
    return [
      // vertices on bottom face, start from left bottom in counter clockwise.
      new Vector3(this.min.x, this.min.y, this.min.z),
      new Vector3(this.max.x, this.min.y, this.min.z),
      new Vector3(this.max.x, this.max.y, this.min.z),
      new Vector3(this.min.x, this.max.y, this.min.z),
      // vertices on top face, start from left bottom in counter clockwise.
      new Vector3(this.min.x, this.min.y, this.max.z),
      new Vector3(this.max.x, this.min.y, this.max.z),
      new Vector3(this.max.x, this.max.y, this.max.z),
      new Vector3(this.min.x, this.max.y, this.max.z)
    ];
  }

  includePoint(point: Vector3) {
    this.min.min(point);
    this.max.max(point);

    return this;
  }

  includePoints(points: Vector3[]) {
    const _this = this;
    points.forEach(function (point) {
      return _this.includePoint(point);
    });

    return this;
  }

  setFromCenterAndSize(center: Vector3, size: Vector3) {
    const halfSize = size.clone().multiplyScalar(0.5);
    this.min.copy(center).sub(halfSize);
    this.max.copy(center).add(halfSize);
    return this;
  }
}
